import { PasswordRoutes } from '@/repository/auth';
const { SendResetLink, SaveNewPassword, UpdatePassword } = PasswordRoutes;

export default {
	namespaced: true,
	actions: {
		async storeResetLink({ },data) {
			try {
				return await SendResetLink(data)
			}
			catch (error) {
				console.error('Password reset Link could not be sent.', error);
				throw error;
			}
		},
		async storeNew({ },data) {
			try {
				return await SaveNewPassword(data)
			}
			catch (error) {
				console.error('Password could not be updated.', error);
				throw error;
			}
		},
		async update({ },data) {
			try {
				return await UpdatePassword(data)
			}
			catch (error) {
				console.error('Password could not be updated.', error);
				throw error;
			}
		}
	}
}